import React, {useState} from 'react';
import './ChangeNicknamePage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {getNicknameError, MAX_NICKNAME_LENGTH} from '../../../configs/nickname';

const PAGE_ID = 'ChangeNicknamePage';

/**
 * Смена никнейма пользователя суперадмином. Правила имени берутся из общего
 * конфига (configs/nickname) — теми же проверяет сервер; занятость никнейма
 * знает только сервер, поэтому его ответ показывается как есть.
 */
function ChangeNicknamePage({targetUserId, targetUserName, onBack, onRenamed}) {
  usePageAnalytics(PAGE_ID);

  const [name, setName] = useState(targetUserName || '');
  const [error, setError] = useState(null);
  const [savedName, setSavedName] = useState(null);
  const [saving, setSaving] = useState(false);

  const trimmedName = name.trim();
  const isUnchanged = trimmedName === (targetUserName || '');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (saving) return;

    setSavedName(null);

    const validationError = getNicknameError(trimmedName);
    if (validationError) {
      setError(validationError);
      return;
    }
    if (isUnchanged) {
      setError('Это тот же самый никнейм');
      return;
    }

    setSaving(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE}/admin/change-nickname`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({targetUserId, name: trimmedName}),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || 'Не удалось сменить никнейм');
      }

      setSavedName(data.name);
      // Никнейм показан на десятке экранов (профиль, заголовки, история) —
      // сообщаем наверх, чтобы они не остались со старым до перезагрузки
      onRenamed?.(data.name);
    } catch (e) {
      console.error('Change nickname error', e);
      setError(e.message || 'Не удалось сменить никнейм');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <h1 className="lobby-page-title change-nickname-page-title">
        Сменить никнейм
        {targetUserName && <span className="change-nickname-page-subtitle">{targetUserName}</span>}
      </h1>

      <form className="auth-form change-nickname-form" onSubmit={handleSubmit}>
        <label className="auth-label">Новый никнейм:</label>
        <input
          className="auth-input"
          type="text"
          value={name}
          onChange={(event) => {
            setName(event.target.value);
            if (error) setError(null);
            if (savedName) setSavedName(null);
          }}
          maxLength={MAX_NICKNAME_LENGTH}
          disabled={saving}
          autoFocus
        />
        {error && <p className="auth-error">{error}</p>}
        {savedName && <p className="change-nickname-success">Никнейм изменен на «{savedName}»</p>}
        <PageButton
          type="submit"
          pageId={PAGE_ID}
          buttonId="save"
          disabled={saving || !trimmedName || isUnchanged}
        >
          {saving ? 'Сохраняю...' : 'Сохранить'}
        </PageButton>
      </form>

      <div className="main-menu-buttons change-nickname-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default ChangeNicknamePage;
